// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (orientation: landscape) {
  .extra-discount-plan-section {
    max-width: var(--content-max-width);
  }
}

.ReactModal__Body--open .extra-discount-plan-section{
  display: none;
}

.extra-discount-plan-section {
    width: 100%;
    background-color: #FFF6C6;
    position: sticky;
    top: 0;
    z-index: 2;
}

.extra-discount-plan-section .extra-discount-container {
  padding: 0 24px;
}

.extra-discount-plan-section .extra-discount-container .item {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: space-between;
  padding: 16px 0;
  width: 100%;
}

.extra-discount-plan-section .extra-discount-container .item img {
  width: 87px;
  height: 87px;
}

.extra-discount-plan-section .extra-discount-container .item .text {
  text-decoration: line-through;
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
}

.extra-discount-plan-section .extra-discount-container .item .text span {
  text-decoration: line-through;
  font-weight: 700;
  font-size: 15px;
}

.extra-discount-plan-section .extra-discount-container .item .description {
  margin-top: 7px;
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  color: #000000;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.extra-discount.css"],"names":[],"mappings":"AAAA;EACE;IACE,mCAAmC;EACrC;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["@media (orientation: landscape) {\n  .extra-discount-plan-section {\n    max-width: var(--content-max-width);\n  }\n}\n\n.ReactModal__Body--open .extra-discount-plan-section{\n  display: none;\n}\n\n.extra-discount-plan-section {\n    width: 100%;\n    background-color: #FFF6C6;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n}\n\n.extra-discount-plan-section .extra-discount-container {\n  padding: 0 24px;\n}\n\n.extra-discount-plan-section .extra-discount-container .item {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  padding: 16px 0;\n  width: 100%;\n}\n\n.extra-discount-plan-section .extra-discount-container .item img {\n  width: 87px;\n  height: 87px;\n}\n\n.extra-discount-plan-section .extra-discount-container .item .text {\n  text-decoration: line-through;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 18px;\n}\n\n.extra-discount-plan-section .extra-discount-container .item .text span {\n  text-decoration: line-through;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.extra-discount-plan-section .extra-discount-container .item .description {\n  margin-top: 7px;\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: 700;\n  color: #000000;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
